import { useRef } from "react";
import { SYPlayer, Transport } from "webgl-render-library";

import { newRelic } from "utils/logUtils";
import { trackEventVideoRenderedError } from "utils/gAnalyticsUtils";

const useWebGlPlayer = (params) => {
  const transportRef = useRef(null);
  const playerRef = useRef(null);

  const init = () => {
    try {
      playerRef.current = new SYPlayer(params);
      playerRef.current.addEventListener("loaded", (event) => {
        transportRef.current = new Transport(event.currentTarget); // eslint-disable-line
      });
    } catch (error) {
      console.error(error);
      newRelic(`WebGL Player Error: ${error.message}`, error);
      trackEventVideoRenderedError("WebGL");
    }
  };

  const cleanup = () => {
    playerRef.current.removeEventListener("loaded", null);
    playerRef.current.destroy();

    if (transportRef.current) {
      transportRef.current.destroy();
    }

    playerRef.current = null;
    transportRef.current = null;
  };

  const exitFullscreen = () => transportRef.current.closeFullScreen();

  const resetPlayer = () => {
    playerRef.current.seekTo(0);
    playerRef.current.pause();
  };

  return { init, cleanup, playerRef, exitFullscreen, resetPlayer };
};

export default useWebGlPlayer;
